import { render } from "./jpg-icon.svg?vue&type=template&id=51fc5930"
import script from "./jpg-icon.svg?vue&type=script&lang=js"
export * from "./jpg-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1152/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__